export const a11yTicketId = (ticket: wix.events.ticketing.TicketDefinition) => `ticket-${ticket.id}`
export const a11yTicketTypeId = (ticket: wix.events.ticketing.TicketDefinition) => `ticket-type-${ticket.id}`
export const a11yPriceId = (priceId: string) => `price-${priceId}`
export const a11yLabelId = (elementId: string) => `label-${elementId}`
export const a11yTaxId = (elementId: string) => `tax-${elementId}`
export const a11yFeeId = (elementId: string) => `fee-${elementId}`
export const a11yAdditionalFeesId = (elementId: string) => `additional-fees-${elementId}`
export const a11yPlaceFeesId = (placeId: string) => `place-fees-${placeId}`
